import { render, staticRenderFns } from "./year-echarts.vue?vue&type=template&id=6fbba584&scoped=true&"
import script from "./year-echarts.vue?vue&type=script&lang=js&"
export * from "./year-echarts.vue?vue&type=script&lang=js&"
import style0 from "./year-echarts.vue?vue&type=style&index=0&id=6fbba584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbba584",
  null
  
)

export default component.exports